"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HitEventNames = void 0;
var _ = require("lodash");
exports.HitEventNames = {
    INSURED_AND_OWNER_DATA_UPDATED: {
        name: 'InsuredAndOwnerDataUpdated'
    },
    INSURED_DATA_UPDATED: {
        name: 'InsuredDataUpdated'
    },
    OWNER_DATA_UPDATED: {
        name: 'OwnerDataUpdated'
    },
    APPLICATION_MVR_DATA_UPDATED: {
        name: 'ApplicationMvrDataUpdated'
    },
    AU_OFFER_CONFIRMED: {
        name: 'AUOfferConfirmed'
    },
    TLIC_OFFER_SIGNED: {
        name: 'TLICOfferSigned'
    },
    NON_TLIC_APPLICATION_SIGNED: {
        name: 'NonTLICApplicationSigned'
    },
    CANCEL: {
        name: 'Cancel'
    },
    CANCELED_BY_CUSTOMER: {
        name: 'CanceledByCustomer'
    },
    POLICY_FREE_LOOK: {
        name: 'PolicyFreeLook'
    },
    POLICY_FREE_LOOK_ENDED: {
        name: 'PolicyFreeLookEnded'
    },
    REFLEXIVE_QUESTIONS_ANSWERED: {
        name: 'ReflexiveQuestionsAnswered'
    },
    POLICY_TERMINATED_LAPSED: {
        name: 'PolicyTerminatedLapsed'
    },
    POLICY_TERMINATED_FREE_LOOKED: {
        name: 'PolicyTerminatedFreeLooked'
    },
    POLICY_TERMINATED_CANCELED: {
        name: 'PolicyTerminatedCanceled'
    },
    POLICY_TERMINATED_NOT_TAKEN: {
        name: 'PolicyTerminatedNotTaken'
    },
    POLICY_TERMINATED_RESCINDED: {
        name: 'PolicyTerminatedRescinded'
    },
    INSURED_FOLLOWUP_COMPLETED: {
        name: 'InsuredFollowUpCompleted'
    },
    HIGH_FACE_AMOUNT_SELECTED: {
        name: 'HighFaceAmountSelected'
    },
    POLICY_DOCS_RETRIEVED: {
        name: 'PolicyDocsRetrieved'
    },
    OPERATIONS_REVIEW: {
        name: 'OperationsReview'
    },
    APPS_APPOINTMENT_DETAILS: {
        name: 'AppsAppointmentDetails'
    },
    DOC_UPLOADED_BY_FOREIGN_CITIZEN: {
        name: 'DocUploadedByForeignCitizen'
    },
    find: function (name) {
        var matcher = {
            name: name
        };
        return this._findMatch(matcher);
    },
    _findMatch: function (matcher) {
        return _.find(_.values(this), matcher);
    }
};
//# sourceMappingURL=HitEventName.js.map